/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ChangeUserStateDtoTx,
  Common,
  GetMenuDtoRx,
  GetSignUpUserDtoRx,
  GetUpdateUserDtoRx,
  GetUserDtoRx,
  SigninDto,
  SignUpDtoTx,
  Token,
  UpdateUserDtoTx,
  UpdateUserPasswordDtoTx,
  UserControllerGetUsersParams,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class UserApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerGetUsers
   * @summary 회원 목록 조회
   * @request GET:/api/user
   * @secure
   */
  userControllerGetUsers = (query: UserControllerGetUsersParams, params: RequestParams = {}) =>
    this.request<GetUserDtoRx, any>({
      path: `/api/user`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerSignin
   * @summary 로그인
   * @request POST:/api/user/signin
   */
  userControllerSignin = (data: SigninDto, params: RequestParams = {}) =>
    this.request<Token, any>({
      path: `/api/user/signin`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerMenu
   * @summary 메뉴 조회
   * @request GET:/api/user/menu
   * @secure
   */
  userControllerMenu = (params: RequestParams = {}) =>
    this.request<GetMenuDtoRx, any>({
      path: `/api/user/menu`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerGetSignUpUser
   * @summary 회원 등록에 필요한 데이터 반환
   * @request GET:/api/user/signup
   */
  userControllerGetSignUpUser = (params: RequestParams = {}) =>
    this.request<GetSignUpUserDtoRx, any>({
      path: `/api/user/signup`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerSignUpUser
   * @summary 회원 등록
   * @request POST:/api/user/signup
   */
  userControllerSignUpUser = (data: SignUpDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user/signup`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerCheckPassid
   * @summary 아이디 중복 확인
   * @request GET:/api/user/check/{passid}
   */
  userControllerCheckPassid = (passid: string, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user/check/${passid}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerReissue
   * @summary 토큰 재발급
   * @request GET:/api/user/auth/reissue
   * @secure
   */
  userControllerReissue = (params: RequestParams = {}) =>
    this.request<Token, any>({
      path: `/api/user/auth/reissue`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerSignUpUserTest
   * @summary 회원 등록: 테스트 용으로 유저 타입과 사이트도 그냥 테스트로 생성
   * @request POST:/api/user/signup/test
   */
  userControllerSignUpUserTest = (data: SignUpDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user/signup/test`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerUpdateUserPassword
   * @summary 비밀번호 변경
   * @request PUT:/api/user/password
   * @secure
   */
  userControllerUpdateUserPassword = (data: UpdateUserPasswordDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user/password`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerGetUser
   * @summary 회원 조회 (수정에 필요한 데이터 반환)
   * @request GET:/api/user/{id}
   * @secure
   */
  userControllerGetUser = (id: number, params: RequestParams = {}) =>
    this.request<GetUpdateUserDtoRx, any>({
      path: `/api/user/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerUpdateUser
   * @summary 회원 수정
   * @request PUT:/api/user/{id}
   * @secure
   */
  userControllerUpdateUser = (id: number, data: UpdateUserDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerApproveUser
   * @summary 회원 승인
   * @request POST:/api/user/approval
   * @secure
   */
  userControllerApproveUser = (data: ChangeUserStateDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user/approval`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User API
   * @name UserControllerRejectUser
   * @summary 회원 반려
   * @request POST:/api/user/reject
   * @secure
   */
  userControllerRejectUser = (data: ChangeUserStateDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user/reject`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
